<div class="cr-input__container" [ngClass]="{ 'cr-field-invalid': invalid }">
  <div class="cr-input__header">
    <div class="cr-input__label-wrapper">
      <label *ngIf="label" [for]="id" class="cr-input__label">{{
        label
      }}</label>

      <div class="cr-input__label-helper" *ngIf="labelHelper">
        <ng-template #labelHelperString>
          <span
            class="cr-input__text-helper--warning cr-badge cr-badge--info cr-badge--small"
            >{{ labelHelper }}</span
          >
        </ng-template>
        <ng-container
          [ngTemplateOutlet]="labelHelper?.templateRef || labelHelperString"
        >
          <ng-template #labelHelperString> </ng-template>
        </ng-container>
      </div>
    </div>

    <div class="cr-input__description" *ngIf="description">
      {{ description }}
    </div>
  </div>

  <label
    class="cr-input__wrapper"
    [class.cr-input__wrapper--disabled]="disabled"
    [ngClass]="{
      'cr-field--small': size === 'small',
      'cr-field--large': size === 'large'
    }"
  >
    <div class="cr-input__prefix" *ngIf="prefix">
      <ng-container [ngTemplateOutlet]="prefix?.templateRef || prefixString">
        <ng-template #prefixString>{{ prefix }}</ng-template>
      </ng-container>
    </div>

    <ng-content></ng-content>

    <div class="cr-input__suffix" *ngIf="suffix">
      <ng-container [ngTemplateOutlet]="suffix?.templateRef || suffixString">
        <ng-template #suffixString>{{ suffix }}</ng-template>
      </ng-container>
    </div>

    <div class="cr-input__backdrop"></div>
  </label>

  <p class="cr-input__text-helper--error">
    <ng-content select="[field-errors]"></ng-content>
  </p>

  <div
    color="gray-300"
    [class.cr-input__text-helper--error]="status === 'error'"
    [class.cr-input__text-helper--warning]="status === 'warning'"
    [class.cr-input__text-helper--valid]="status === 'valid'"
    [class.cr-input__text-helper--status]="status"
    *ngIf="textHelper"
    class="cr-input__text-helper cr-input--small"
  >
    {{ textHelper }}
  </div>
</div>
